import { Injectable } from '@angular/core';
import { KeyValueStoreService } from './key-value-store.service';

export interface MessageInfo {
  messageId: string;
  date: Date;
}

@Injectable({
  providedIn: 'root',
})
export class ImageDownloadLogsService {
  messageInfoTable: LocalForage;

  constructor(private keyValueStoreService: KeyValueStoreService) {
    this.initImageDownloadDB();
  }

  initImageDownloadDB(): void {
    this.messageInfoTable = this.keyValueStoreService.createTable('ImageDownloadDB', 'MessageInfo');
  }

  // Belirli kullanıcı verisini getir veya yeni oluştur
  async getUserData(userLoginEmail: string): Promise<Record<string, MessageInfo[]>> {
    const data = await this.keyValueStoreService.get(this.messageInfoTable, userLoginEmail);
    return data || {};
  }

  // Belirli bir e-posta adresine bir mesaj bilgisi ekle
  async addMessage(userLoginEmail: string, email: string, message: MessageInfo): Promise<void> {
    const userData = await this.getUserData(userLoginEmail);

    const emailMessages = userData[email] || [];

    // Aynı mesaj ID varsa tekrar ekleme
    const alreadyExists = emailMessages.some(msg => msg.messageId === message.messageId);
    if (!alreadyExists) {
      emailMessages.push(message);
      userData[email] = emailMessages;
      await this.setTable(userLoginEmail, userData);
    }
  }

  async hasMessage(userLoginEmail: string, email: string, messageId: string): Promise<boolean> {
    const userData = await this.getUserData(userLoginEmail);
    const emailMessages = userData[email];
    return emailMessages ? emailMessages.some(msg => msg.messageId === messageId) : false;
  }

  // Belirli kullanıcının tüm email'lerini getir
  async getMessagesForUser(userLoginEmail: string): Promise<Record<string, MessageInfo[]> | null> {
    return await this.keyValueStoreService.get(this.messageInfoTable, userLoginEmail);
  }

  // Belirli kullanıcının belirli email'ine ait tüm mesajları getir
  async getMessagesForEmail(userLoginEmail: string, email: string): Promise<MessageInfo[] | null> {
    const userData = await this.getUserData(userLoginEmail);
    return userData[email] || null;
  }

  // Belirli kullanıcının belirli email'ini sil
  async clearMessagesForEmail(userLoginEmail: string, email: string): Promise<void> {
    const userData = await this.getUserData(userLoginEmail);
    delete userData[email];
    await this.setTable(userLoginEmail, userData);
  }

  // Belirli kullanıcı için tüm datayı sil
  async clearMessagesForUser(userLoginEmail: string): Promise<void> {
    await this.keyValueStoreService.remove(this.messageInfoTable, userLoginEmail);
  }

  // Tüm veriyi sil
  async clearAll(): Promise<void> {
    await this.keyValueStoreService.deleteAll(this.messageInfoTable);
  }

  async setTable(userLoginEmail: string, userData: any): Promise<any> {
    await this.keyValueStoreService.set(this.messageInfoTable, userLoginEmail, userData);
  }
}
